import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import {
  GET_FAVOURITES_COLLAPSED,
  getExpandedFoldersChange$,
  SET_FAVOURITES_COLLAPSED,
} from '../../../account-list/utils/account-list.ui.store';
import { PreferencesService } from '../../../preferences/preferences-service/preferences.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { iconMap } from 'src/app/project/shared/enums/icon-map';

@Component({
  selector: 'pp-side-panel-favourites-row',
  templateUrl: './side-panel-favourites-row.component.html',
  styleUrl: './side-panel-favourites-row.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelFavouritesRowComponent implements OnInit, OnDestroy {
  @Output() ppUpdate: EventEmitter<void> = new EventEmitter<void>();

  isCollapsed: boolean;
  EIconPath = EIconPath;
  iconMap = iconMap;
  favouritesCount: number;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private preferencesService: PreferencesService,
    private workspaceService: WorkspaceService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.isCollapsed = GET_FAVOURITES_COLLAPSED();

    getExpandedFoldersChange$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isCollapsed = GET_FAVOURITES_COLLAPSED();
        this.cd.markForCheck();
      });

    this.countFavorites();

    this.preferencesService.favouritesChange$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.countFavorites();
      this.cd.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    SET_FAVOURITES_COLLAPSED(this.isCollapsed);
    this.ppUpdate.emit();
  }

  countFavorites(): void {
    let count = 0;
    const favouriteWorkspaces = this.preferencesService.getPreferences().favouriteWorkspaceIds;

    favouriteWorkspaces.forEach((workspaceId) => {
      const workspace = this.workspaceService.getWorkspace(workspaceId);

      if (workspace) {
        count += 1;
      }
    });

    this.favouritesCount = count;
  }
}
